<template>
	<div class="mh-middle">
		<div class="mh-middle-inner">
			<div class="mh-time-top">
				<b-row no-gutters>
					<b-col align-self="center" lg="6" md="12">
						<h2>My Participants / Customers</h2>
					</b-col>
					<b-col align-self="center" lg="6" md="12">
						<div class="mh-time-search">
							<div class="mh-time-search-inner">
								<i class="mh-icon-search"></i>
								<input type="text" placeholder="Search Here..." v-model="search">
							</div>
						</div>
					</b-col>
				</b-row>
			</div>

			<div v-if="!isViewing" class="mh-middle-container">
				<div class="mh-time-entries-top mh-time-off">
					<b-row class="m-0">
						<b-col cols="12" class="p-0">
							<div class="table-reponsive mh-customers-list">
								<div class="dataTables_wrapper no-footer">
									<data-table v-bind="bindings"
												:showPerPage="false"
												:showEntriesInfo="false"
												:showSearchFilter="false"
												:showPagination="true"
												:showDownloadButton="false"
												sortingMode="single"
												tableClass="table table-curved dataTable"
												ref="dataTable" />
								</div>
							</div>
						</b-col>
					</b-row>
				</div>
			</div>

			<div v-else ref="forms">
				<b-col cols="12" class="p-0">
					<b-card no-body class="mh-card mh-card-page">
						<b-card-header class="mh-bg-primary d-flex align-items-center">
							<h3 class="card-title">Customer Profile</h3>
							<div class="col-auto ml-auto p-0">
								<button type="button" class="btn btn-link mh-btn-icon" @click="cancelView"><i class="mh-icon-close"></i></button>
							</div>
						</b-card-header>
						<b-card-body class="mh-off-middle">
							<b-row no-gutters>
								<b-col cols="12" class="mb-2">
									<b-row no-gutters>
										<b-col cols="12">
											<div class="mh-profile-label">
												<div class="mh-img-wrap">
													<ProfileImage :imageUrl="customerProfilePicture" />
													<span class="mh-user-online"></span>
												</div>
												<span class="mh-title">{{selectedRecord.name}}</span>
											</div>
										</b-col>
									</b-row>
									<b-row no-gutters>
										<b-col cols="6" class="label">
											Gender
										</b-col>
										<b-col v-if="selectedRecord.gendername != ''" cols="6">
											{{selectedRecord.gendername}}
										</b-col>
										<b-col v-else cols="6" class="not-specified">
											Not Specified
										</b-col>
									</b-row>
									<b-row no-gutters>
										<b-col cols="6" class="label">
											Age
										</b-col>
										<b-col v-if="selectedRecord.dateofbirth != ''" cols="6">
											{{Math.floor(moment.duration(moment().diff(moment(selectedRecord.dateofbirth, 'D/MM/YYYY'))).asYears())}}
										</b-col>
										<b-col v-else cols="6" class="not-specified">
											Not Specified
										</b-col>
									</b-row>
									<b-row no-gutters>
										<b-col cols="6" class="label">
											NDIS Number
										</b-col>
										<b-col v-if="selectedRecord.ndisnumber != ''" cols="6">
											{{selectedRecord.ndisnumber}}
										</b-col>
										<b-col v-else cols="6" class="not-specified">
											Not Specified
										</b-col>
									</b-row>
									<b-row no-gutters>
										<b-col cols="6" class="label">
											Keyworker
										</b-col>
										<b-col v-if="selectedRecord.keyworkername != ''" cols="6">
											{{selectedRecord.keyworkername}}
										</b-col>
										<b-col v-else cols="6" class="not-specified">
											Not Specified
										</b-col>
									</b-row>
									<b-row no-gutters>
										<b-col cols="6" class="label">
											Address
										</b-col>
										<b-col v-if="selectedRecord.combinedaddress != ''" cols="6">
											{{selectedRecord.combinedaddress}}
										</b-col>
										<b-col v-else cols="6" class="not-specified">
											Not Specified
										</b-col>
									</b-row>
									<b-row no-gutters>
										<b-col cols="6" class="label">
											Home Phone
										</b-col>
										<b-col v-if="selectedRecord.homephone != ''" cols="6">
											{{selectedRecord.homephone}}
										</b-col>
										<b-col v-else cols="6" class="not-specified">
											Not Specified
										</b-col>
									</b-row>
									<b-row no-gutters>
										<b-col cols="6" class="label">
											Mobile Phone
										</b-col>
										<b-col v-if="selectedRecord.mobilephone != ''" cols="6">
											{{selectedRecord.mobilephone}}
										</b-col>
										<b-col v-else cols="6" class="not-specified">
											Not Specified
										</b-col>
									</b-row>
									<b-row no-gutters>
										<b-col cols="6" class="label">
											Email
										</b-col>
										<b-col v-if="selectedRecord.email != ''" cols="6">
											{{selectedRecord.email}}
										</b-col>
										<b-col v-else cols="6" class="not-specified">
											Not Specified
										</b-col>
									</b-row>
								</b-col>
								<b-col cols="12" class="notes">
									<b-row no-gutters>
										<b-col cols="12" class="label">
											Notes
										</b-col>
										<b-col v-if="shiftSummeries.length > 0" cols="12">
											<b-row v-for="(shiftSummery, index) in filteredShiftSummeries" :key="index" class="note" no-gutters>
												<b-col cols="12" class="name">{{shiftSummery.name}}</b-col>
												<b-col cols="12" class="service-date">{{moment(shiftSummery.servicedate, "DD/MM/YYYY").format("ddd, DD-MM-YYYY")}}</b-col>
												<b-col cols="auto" class="shift">{{shiftSummery.shift}}</b-col>
												<b-col cols="6" class="total-hours">{{shiftSummery.totalhours}} hrs</b-col>
												<b-col cols="12" class="shift-notes" v-html="shiftSummery.shiftnotes"></b-col>
											</b-row>
										</b-col>
										<b-col v-else cols="12" class="not-specified">
											There is noting to display
										</b-col>
										<b-col v-if="shiftSummeries.length > 0" cols="12" class="pagination">
											<b-row class="justify-content-end">
												<b-col cols="auto"
													   :class="`nav${selectedPage === 0 ? ' disabled' : ''}`"
													   v-on="selectedPage > 0 ? { click: () => changePage(selectedPage - 1) } : {}">
													<icon name="angle-double-left" scale="2"></icon>
												</b-col>
												<b-col v-for="(n, index) in shiftSummeryPages"
													   :key="index"
													   cols="auto"
													   :class="`nav${selectedPage === index ? ' active' : ''}`"
													   @click="changePage(index)">
													{{index + 1}}
												</b-col>
												<b-col cols="auto"
													   :class="`nav${selectedPage + 1 === shiftSummeryPages ? ' disabled' : ''}`"
													   v-on="selectedPage + 1 < shiftSummeryPages ? { click: () => changePage(selectedPage + 1) } : {}">
													<icon name="angle-double-right" scale="2"></icon>
												</b-col>
											</b-row>
										</b-col>
									</b-row>
								</b-col>
							</b-row>
						</b-card-body>
					</b-card>
				</b-col>
			</div>
		</div>
	</div>
</template>

<script>
	import ContentTitle from "./partials/ContentTitle"
	import ProfileImage from "./partials/ProfileImage"
	import SortingIcon from "./partials/SortingIcon"
	import TableRowActions from "./partials/TableRowActions"
	import { bus } from "./../main"
	import moment from "moment"

	export default {
		name: 'CustomersContent',
		components: {
			ContentTitle,
			ProfileImage,
			SortingIcon,
			TableRowActions
		},
		data: function () {
			return {
				search: "",
				viewing: false,
				selectedRecord: {},
				pageLength: 20,
				selectedPage: 0
			}
		},
		mounted: function () {
			this.$store.dispatch("Customers/getCustomers")

			bus.$off('viewDetailsTableRowAction')
			bus.$on('viewDetailsTableRowAction', obj => { this.viewRow(obj) })
		},
		watch: {
			search: {
				immediate: true,
				handler(newValue, oldValue) {
					if (this.$refs.dataTable != null) {
						this.$refs.dataTable.search = newValue
						this.$refs.dataTable.setSearch()
					}
				}
			}
		},
		computed: {
			isViewing: function () {
				return this.viewing
			},
			records: function () {
				var icons = [
					{
						class: "mh-icon-eye",
						title: "View",
						emit: "viewDetailsTableRowAction"
					}
				]

				return this.$store.state.Customers.customers
					.map(x => {
						return {
							id: x.id,
							name: x.name,
							combinedaddress: x.combinedaddress,
							email: x.email,
							risknotification: x.risknotification,
							dateofbirth: x.dateofbirth,
							homephone: x.homephone,
							mobilephone: x.mobilephone,
							ndisnumber: x.ndisnumber,
							keyworkername: x.keyworkername,
							gendername: x.gendername,
							profilepic: x.profilepic,
							icons: icons
						}
					})
					.filter(x => {
						return (this.status == 0 || this.status == x.status)
							&& ((x.name + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
								|| (x.combinedaddress + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
								|| (x.risknotification + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1)
					})
			},
			columns: function () {
				var columns = [
					{ key: "name", title: "Name", searchable: true, sortable: true },
					{ key: "combinedaddress", title: "Address", searchable: true, sortable: true },
					{ key: "risknotification", title: "Risk Notification", searchable: true, sortable: true },
					{ key: "", title: "", component: TableRowActions }
				]

				return columns
			},
			bindings: function () {
				return {
					SortingIconComponent: SortingIcon,
					columns: this.columns,
					data: this.records
				}
			},
			shiftSummeries: function () {
				return this.$store.state.Customers.shiftSummeries
			},
			filteredShiftSummeries: function () {
				var start = this.selectedPage === 0 ? 0 : (this.selectedPage * this.pageLength)

				return this.$store.state.Customers.shiftSummeries.slice(start, start + this.pageLength)
			},
			shiftSummeryPages: function () {
				return Math.ceil(this.shiftSummeries.length / this.pageLength)
			},
			customerProfilePicture: function () {
				return this.selectedRecord.profilepic
			}
		},
		methods: {
			changePage: function (page) {
				this.selectedPage = page
			},
			setSelectedRecord: function (id) {
				this.selectedRecord = this.records.filter(x => x.id == id)[0]
			},
			cancelView: function () {
				this.viewing = false
				this.selectedRecord = null
			},
			viewRow: function (obj) {
				var $this = this

				this.$store.dispatch("Customers/getClientShiftSummary", obj.id).then(function () {
					$this.viewing = true
					$this.selectedPage = 0
					$this.setSelectedRecord(obj.id)
				})
			}
		}
	};
</script>

<style scoped>
	.mh-off-middle > .row > div > .row {
		margin-bottom: 10px;
	}

	.label {
		font-weight: bold;
	}

	.pagination {
		user-select: none;
	}

		.pagination .nav {
			padding: 0.5em 1em;
			border: 1px solid #7F92B8;
			border-left: none;
			font-weight: bold;
			line-height: 32px;
			color: #7F92B8;
			cursor: pointer;
		}

			.pagination .nav.active {
				color: #081E4A;
			}

			.pagination .nav:first-child {
				border-left: 1px solid #7F92B8;
				border-radius: 2em 0 0 2em;
			}

			.pagination .nav:last-child {
				border-radius: 0 2em 2em 0;
			}

			.pagination .nav svg {
				position: relative;
				right: 0;
			}

	.notes {
		height: 100%;
		border-radius: 15px;
	}

		.notes .title {
			margin-bottom: 10px;
			padding: 7px;
			font-weight: bold;
			text-align: center;
			font-size: 16px;
			background-color: #081e4a;
			border-radius: 100px;
		}

		.notes .note {
			margin-bottom: 15px;
			padding: 5px;
			font-size: 13px;
		}

			.notes .note:not(:last-child) {
				border-bottom: 1px solid #dfdfdf;
			}

			.notes .note > div {
				padding-left: 5px;
				padding-right: 5px;
			}

			.notes .note .name {
				font-size: 14px;
				font-weight: bold;
			}

			.notes .note .shift {
				padding: 0 10px 0 20px;
				font-weight: bold;
			}

				.notes .note .shift::before {
					position: absolute;
					top: 0;
					left: 5px;
					content: '\42';
					font-family: 'Mopane';
					font-size: 11px;
				}

			.notes .note .total-hours::before {
				position: absolute;
				top: -1px;
				left: -5px;
				content: "\25CF";
			}

			.notes .note .shift-notes {
				padding: 5px !important;
				font-weight: 400;
				color: #e94a79;
			}
</style>